import { StyleSheet } from 'react-native';
import React, { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { muteAll, useFetchOld } from 'hooks';
import { joinGroup } from 'actions';
import { useMainStackNavigation, } from 'utils/types/navigationV6';
import { useAppSelector } from 'store/hooks';
import { selectIsGBUser } from 'reducers/selectors';
import AddGroupModalContent from '../components/AddGroupModalContent';
export const useAddGroupModal = () => {
    const navigation = useMainStackNavigation();
    const [, , , fetch] = useFetchOld(muteAll);
    const didViewGroupsIntro = useAppSelector((store) => store.deviceSettings.didViewGroupsIntro);
    const groups = useAppSelector((store) => store.groups.groups);
    const isGBUser = useAppSelector(selectIsGBUser);
    const onCreateGroup = useCallback(() => {
        if (!didViewGroupsIntro && !groups.length && isGBUser) {
            navigation.navigateDeprecated('GroupsIntro', {
                buttonLabel: 'Create a group',
                onContinue: () => navigation.navigateDeprecated('GroupCreate'),
            });
        }
        else {
            navigation.navigateDeprecated('GroupCreate');
        }
    }, [didViewGroupsIntro, groups.length, isGBUser]);
    const onJoinGroup = useCallback(() => {
        const navigateToEnterGroupCode = () => {
            navigation.navigateDeprecated('TextFieldPage', {
                title: 'Enter the group code',
                onBackPress: (navigation) => navigation.pop(),
                placeholder: 'Group code',
                buttonTitle: 'Continue',
                onPressNext: async (value, setFetching) => {
                    setFetching(true);
                    const res = await fetch(joinGroup(value));
                    setFetching(false);
                    if (res) {
                        navigation.navigateDeprecated('Success', {
                            title: 'Whooray!',
                            subTitle: `You have joined the ${res.group.name} group!`,
                            onContinue: () => {
                                navigation.popToTop();
                                navigation.navigateDeprecated('Group', { id: res.group.id });
                                return true;
                            },
                            buttonText: 'Continue',
                        });
                    }
                },
            });
        };
        if (!didViewGroupsIntro && !groups.length && isGBUser) {
            navigation.navigateDeprecated('GroupsIntro', {
                buttonLabel: 'Join a group',
                onContinue: navigateToEnterGroupCode,
            });
        }
        else {
            navigateToEnterGroupCode();
        }
    }, [didViewGroupsIntro, groups.length, isGBUser]);
    const show = useCallback(() => {
        Modal.show(<AddGroupModalContent onJoinGroup={onJoinGroup} onCreateGroup={onCreateGroup}/>, {
            containerStyle: styles.modal,
            title: 'Add a group',
        });
    }, [onCreateGroup, onJoinGroup]);
    return { show, onCreateGroup };
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
